import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/mass-molarity/pages/CalculatorPage";

export const Route = createFileRoute("/mass-molarity")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.massmol_meta_title() },
      { name: "description", content: m.massmol_meta_description() },
      { property: "og:title", content: m.massmol_meta_title() },
      { property: "og:description", content: m.massmol_meta_description() },
      ...i18nOgMeta("/mass-molarity"),
    ],
    links: [...i18nLinks("/mass-molarity")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.sci_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.massmol_tool_name(),
              item: localeUrl(`/mass-molarity`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            { q: m.massmol_faq_q1(), a: m.massmol_faq_a1() },
            { q: m.massmol_faq_q2(), a: m.massmol_faq_a2() },
            { q: m.massmol_faq_q3(), a: m.massmol_faq_a3() },
            { q: m.massmol_faq_q4(), a: m.massmol_faq_a4() },
          ].map(({ q, a }) => ({
            "@type": "Question",
            name: q,
            acceptedAnswer: { "@type": "Answer", text: a },
          })),
        }),
      },
    ],
  }),
  component: CalculatorPage,
});
